import "./index.css";
import TopBar from "./components/TopBar/TopBar.jsx";
import * as React from "react";
import { useState, lazy, Suspense } from "react";
import * as ReactDOM from "react-dom/client";
import { StyledEngineProvider } from "@mui/material/styles";
import HeroSection from "./components/HeroSection/HeroSection.jsx";
import ProjectsSection from "./components/Projects/ProjectsSection.jsx";
import AboutSection from "./components/AboutSection/AboutSection.jsx";
import EmailSection from "./components/EmailSection/EmailSection.jsx";
import Footer from "./components/Footer/Footer.jsx";
import { Toolbar } from "@mui/material";
import ChatBox from "./components/ChatBox/ChatBox.jsx";
import AuroraHero from "./components/AuroraHero/AuroraHero.jsx";
import AchievementMarquee from "./components/AchievementMarquee/AchievementMarquee.jsx";
import { Analytics } from "@vercel/analytics/react";

const Terminal = lazy(() => import("./components/Terminal/Terminal.jsx"));

const App = () => {
  const [showTerminal, setShowTerminal] = useState(false);

  return (
    <main className="flex min-h-screen flex-col bg-[#0A0A0F]">
      <TopBar onTerminalToggle={() => setShowTerminal(true)} />
      <Toolbar sx={{ mb: 0 }} />
      <div className="flex flex-1 w-full">
        <AuroraHero>
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 flex-1 w-full">
            <section id="hero">
              <HeroSection />
            </section>
            <AchievementMarquee />
            <section id="about">
              <AboutSection />
            </section>
            <section id="projects">
              <ProjectsSection />
            </section>
            <section id="contact">
              <EmailSection />
            </section>
          </div>
        </AuroraHero>
      </div>
      <Footer />
      <ChatBox />
      {showTerminal && (
        <Suspense fallback={null}>
          <Terminal onClose={() => setShowTerminal(false)} />
        </Suspense>
      )}
    </main>
  );
};

ReactDOM.createRoot(document.querySelector("#root")).render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <App />
      <Analytics />
    </StyledEngineProvider>
  </React.StrictMode>,
);
